<div class="cal-panel" (click)="$event.stopPropagation()">
  <div class="cal-header">
    <button type="button" class="cal-nav-btn" (click)="prevMonth()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><polyline points="15 18 9 12 15 6"/></svg>
    </button>
    <span class="cal-month-label">{{ viewLabel }}</span>
    <button type="button" class="cal-nav-btn" (click)="nextMonth()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><polyline points="9 18 15 12 9 6"/></svg>
    </button>
  </div>

  <div class="cal-weekdays">
    <span *ngFor="let d of weekdayLabels">{{ d }}</span>
  </div>

  <div class="cal-grid">
    <button type="button" *ngFor="let day of calendarDays" class="cal-day" [class.muted]="!day.inCurrentMonth"
      [class.today]="day.isToday" [class.selected]="day.isSelected || day.isRangeStart || day.isRangeEnd"
      [class.in-range]="day.isInRange" [disabled]="day.isDisabled" (click)="selectDay(day)">
      {{ day.day }}
    </button>
  </div>

  <div class="cal-time" *ngIf="showTime && mode === 'single'">
    <span class="cal-time-label">Time</span>
    <input type="time" class="cal-time-input" [(ngModel)]="pendingTime">
  </div>

  <div class="cal-footer">
    <div class="cal-btn cal-btn-cancel" (click)="cancelPick()">Cancel</div>
    <div class="cal-btn cal-btn-apply" [class.disabled]="!canApply" (click)="apply()">Apply</div>
  </div>
</div>
